export default {
    methods: {
        percentOf(value, percent) {
            return (value / 100) * percent;
        },
    }
}
